import React from 'react'

const NoImage = ({ selectedFolder }: any) => {
    return (
        <div className="lg-empty">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="14" rx="2" />
                <circle cx="8.5" cy="9" r="1.5" />
                <path d="M21 15l-5-5-4 4-3-3-4 4" />
            </svg>
            <p>No photos in “{selectedFolder?.name}” yet</p>
        </div>
    )
}

export default NoImage